import React from 'react';
import { TextButton as TextButtonNew } from './TextButton';
import { convertOldTextButtonProps } from './converter.old';
import type { OldTextButtonProps } from './converter.old';

export type TextButtonProps = OldTextButtonProps;

export const TextButton = React.forwardRef<HTMLButtonElement, TextButtonProps>((props, ref) => {
  return <TextButtonNew {...convertOldTextButtonProps(props)} ref={ref} />;
});
